import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, ORDER_URL } from "../data/site";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-[#5FBDD6] shadow-[0_2px_12px_rgba(0,0,0,0.18)]"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-2 sm:py-3 flex items-center gap-3 sm:gap-5">
        {/* Logo + wordmark */}
        <a
          href="/"
          data-testid="header-logo-link"
          className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0"
        >
          <img
            src="/brand/btw-logo.png"
            alt="BTW – Burgers Tacos Wings & Seafood"
            data-testid="btw-logo"
            className="h-11 sm:h-14 w-auto select-none drop-shadow-[0_2px_4px_rgba(0,0,0,0.15)] shrink-0"
            draggable={false}
          />
          <div className="leading-[0.9] min-w-0 flex-1">
            <div
              className="font-display uppercase text-[#0B0B0B] tracking-tight whitespace-nowrap"
              style={{ fontSize: "clamp(22px, 7vw, 44px)" }}
              data-testid="header-wordmark"
            >
              Burgers · Tacos · Wings
            </div>
            <div
              className="font-bold uppercase tracking-[0.22em] whitespace-nowrap mt-1.5 text-[#0B0B0B]/80"
              style={{ fontSize: "clamp(9px, 2.4vw, 13px)" }}
            >
              & Seafood · Jamaica, Queens
            </div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7 shrink-0">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target={l.external ? "_blank" : undefined}
              rel={l.external ? "noopener noreferrer" : undefined}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`font-bold text-sm tracking-[0.18em] uppercase transition-colors ${
                l.accent
                  ? "text-[#0B0B0B] bg-[#A3D900] hover:bg-[#8ebf00] rounded-full px-4 py-2"
                  : "text-[#0B0B0B] hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Mobile menu toggle */}
        <button
          aria-label="Toggle menu"
          data-testid="header-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#0B0B0B] p-2 -mr-2 shrink-0"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden bg-[#0B0B0B] border-t border-white/10 px-5 py-4">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                target={l.external ? "_blank" : undefined}
                rel={l.external ? "noopener noreferrer" : undefined}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-bold text-base tracking-[0.18em] uppercase ${
                  l.accent ? "text-[#A3D900]" : "text-white"
                }`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={ORDER_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-order-cta"
              className="mt-2 inline-flex items-center justify-center rounded-full bg-[#A3D900] text-[#0B0B0B] font-bold tracking-wider uppercase px-6 py-3 text-sm"
            >
              Order Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
